var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"top":"1px","title":_vm.inputTitle,"visible":_vm.isVisible,"width":"500px","close-on-click-modal":false,"close-on-press-escape":false,"fullscreen":false},on:{"update:visible":function($event){_vm.isVisible=$event},"close":_vm.stopChat}},[_c('voice-chat-view',{ref:"voiceChatView",on:{"stop":_vm.stopChat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }